// extracted by mini-css-extract-plugin
module.exports =  {"popup":"_32bbee5fda--popup--sLi9H","close":"_32bbee5fda--close--NonID","raise_bet_link":"_32bbee5fda--raise_bet_link--WEhGT"};